/**************************************************
 * Nombre:       Seccion_Calculadora
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Porcentajes from "./Componentes/Home_Porcentajes";
import Home_Testimonios from "./Componentes/Home_Testimonios";
import Calculadora_Calculadora from "./Componentes/Calculadora_Calculadora";
import {useEffect} from "react";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Calculadora = () => {

    useEffect(() => {
        irArriba();
    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Calculadora_Calculadora/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Porcentajes/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Testimonios/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Calculadora